import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export interface LoadingRowProps {
  label: string;
}

export function LoadingRow({ label }: Readonly<LoadingRowProps>): React.JSX.Element {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <CircularProgress size={20} />
      <Typography>{label}</Typography>
    </Box>
  );
}

export default LoadingRow;
